import { BfEventOrigin, BfMapLayerGroupId, BfMapMarkerType } from "./api/models";
import { DEBUG_MODE } from "./client";

// Generic
import pngWarningGenericAdvice from "../images/markers/event/warningOtherAdvice.png?h=76&format=png&inline&vite-imagetools";
import {
    default as pngWarningGenericEmergency,
    default as pngWarningGenericEvacuate,
} from "../images/markers/event/warningOtherEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningGenericWatchAndAct from "../images/markers/event/warningOtherWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import {
    default as pngWarningGenericInformation,
    default as pngWarningGenericNa,
    default as pngWarningGenericWhite,
} from "../images/markers/event/warningOtherWhite.png?h=76&format=png&inline&vite-imagetools";
import pngWarningGenericUnknown from "../images/markers/event/warningUnknownWhite.png?h=76&format=png&inline&vite-imagetools";

// Fire warnings
import pngWarningFireAdvice from "../images/markers/event/warningFireAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningFireEmergency from "../images/markers/event/warningFireEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningFireWatchAndAct from "../images/markers/event/warningFireWatchAndAct.png?h=76&format=png&inline&vite-imagetools";

// Cyclones
import pngWarningCycloneAdvice from "../images/markers/event/warningCycloneAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningCycloneEmergency from "../images/markers/event/warningCycloneEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningCycloneWatchAndAct from "../images/markers/event/warningCycloneWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import pngWarningCycloneWhite from "../images/markers/event/warningCycloneWhite.png?h=76&format=png&inline&vite-imagetools";

// Flood
import pngWarningFloodAdvice from "../images/markers/event/warningFloodAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningFloodEmergency from "../images/markers/event/warningFloodEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningFloodWatchAndAct from "../images/markers/event/warningFloodWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import pngWarningFloodWhite from "../images/markers/event/warningFloodWhite.png?h=76&format=png&inline&vite-imagetools";

// Storm
import pngWarningStormAdvice from "../images/markers/event/warningStormAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningStormEmergency from "../images/markers/event/warningStormEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningStormWatchAndAct from "../images/markers/event/warningStormWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import pngWarningStormWhite from "../images/markers/event/warningStormWhite.png?h=76&format=png&inline&vite-imagetools";

// Heat
import pngWarningHeatAdvice from "../images/markers/event/warningHeatAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningHeatEmergency from "../images/markers/event/warningHeatEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningHeatWatchAndAct from "../images/markers/event/warningHeatWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import pngWarningHeatWhite from "../images/markers/event/warningHeatWhite.png?h=76&format=png&inline&vite-imagetools";

// Evacuation
import pngWarningEvacuationAdvice from "../images/markers/event/warningEvacuationAdvice.png?h=76&format=png&inline&vite-imagetools";
import pngWarningEvacuationEmergency from "../images/markers/event/warningEvacuationEmergency.png?h=76&format=png&inline&vite-imagetools";
import pngWarningEvacuationWatchAndAct from "../images/markers/event/warningEvacuationWatchAndAct.png?h=76&format=png&inline&vite-imagetools";
import pngWarningEvacuationWhite from "../images/markers/event/warningEvacuationWhite.png?h=76&format=png&inline&vite-imagetools";

// Roads
import pngRoadClosed from "../images/markers/road/traffic-closed.png?format=png&inline&vite-imagetools";
import pngRoadHazard from "../images/markers/road/traffic-hazard.png?format=png&inline&vite-imagetools";

// Aircraft - Active
import {
    default as pngAircraftTurbo4Active,
    default as pngAircraftTurbo4MediumActive,
} from "../images/markers/aircraft/4-turbo-prop-selected.png?format=png&inline&vite-imagetools";
import pngAircraftHelicopterActive from "../images/markers/aircraft/helicopter-selected.png?format=png&inline&vite-imagetools";
import pngAircraftHeavyActive from "../images/markers/aircraft/marker-airplane-selected.png?format=png&inline&vite-imagetools";
import pngAircraftJet2HeavyActive from "../images/markers/aircraft/wtc-heavy-2-jet-selected.png?format=png&inline&vite-imagetools";
import pngAircraftJet4HeavyActive from "../images/markers/aircraft/wtc-heavy-4-jet-selected.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftProp1LightActive,
    default as pngAircraftTurbo1LightActive,
    default as pngAircraftTurbo1MediumActive,
} from "../images/markers/aircraft/wtc-light-1-prop-selected.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftLightActive,
    default as pngAircraftProp2LightActive,
} from "../images/markers/aircraft/wtc-light-2-prop-selected.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftJet2LightActive,
    default as pngAircraftJet2MediumActive,
} from "../images/markers/aircraft/wtc-medium-2-jet-selected.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftMediumActive,
    default as pngAircraftTurbo2LightActive,
    default as pngAircraftTurbo2MediumActive,
} from "../images/markers/aircraft/wtc-medium-2-turbo-selected.png?format=png&inline&vite-imagetools";
import pngAircraftJet4MediumActive from "../images/markers/aircraft/wtc-medium-4-jet-selected.png?format=png&inline&vite-imagetools";

// Aircraft - Inactive
import {
    default as pngAircraftTurbo4,
    default as pngAircraftTurbo4Medium,
} from "../images/markers/aircraft/4-turbo-prop.png?format=png&inline&vite-imagetools";
import pngAircraftHelicopter from "../images/markers/aircraft/helicopter.png?format=png&inline&vite-imagetools";
import pngAircraftHeavy from "../images/markers/aircraft/marker-airplane.png?format=png&inline&vite-imagetools";
import pngAircraftJet2Heavy from "../images/markers/aircraft/wtc-heavy-2-jet.png?format=png&inline&vite-imagetools";
import pngAircraftJet4Heavy from "../images/markers/aircraft/wtc-heavy-4-jet.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftProp1Light,
    default as pngAircraftTurbo1Light,
    default as pngAircraftTurbo1Medium,
} from "../images/markers/aircraft/wtc-light-1-prop.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftLight,
    default as pngAircraftProp2Light,
} from "../images/markers/aircraft/wtc-light-2-prop.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftJet2Light,
    default as pngAircraftJet2Medium,
} from "../images/markers/aircraft/wtc-medium-2-jet.png?format=png&inline&vite-imagetools";
import {
    default as pngAircraftMedium,
    default as pngAircraftTurbo2Light,
    default as pngAircraftTurbo2Medium,
} from "../images/markers/aircraft/wtc-medium-2-turbo.png?format=png&inline&vite-imagetools";
import pngAircraftJet4Medium from "../images/markers/aircraft/wtc-medium-4-jet.png?format=png&inline&vite-imagetools";

// Advisory
import advisoryCycloneTornado from "../images/markers/event/advisoryCycloneTornado.png?h=56&format=png&inline&vite-imagetools";
import advisoryDamagingWinds from "../images/markers/event/advisoryDamagingWinds.png?h=56&format=png&inline&vite-imagetools";
import advisoryEarthquake from "../images/markers/event/advisoryEarthquake.png?h=56&format=png&inline&vite-imagetools";
import advisoryFireWeather from "../images/markers/event/advisoryFireWeather.png?h=56&format=png&inline&vite-imagetools";
import advisoryFlood from "../images/markers/event/advisoryFlood.png?h=56&format=png&inline&vite-imagetools";
import advisoryHail from "../images/markers/event/advisoryHail.png?h=56&format=png&inline&vite-imagetools";
import advisoryOther from "../images/markers/event/advisoryOther.png?h=56&format=png&inline&vite-imagetools";
import advisoryStorm from "../images/markers/event/advisoryStorm.png?h=56&format=png&inline&vite-imagetools";

// Incidents
import incidentWindDamaging from "../images/markers/event/incidentDamagingWinds.png?h=70&format=png&inline&vite-imagetools";
import incidentFireBurn from "../images/markers/event/incidentFireBurn.png?h=70&format=png&inline&vite-imagetools";
import incidentFireControlled from "../images/markers/event/incidentFireControlled.png?h=70&format=png&inline&vite-imagetools";
import incidentFireUncontrolled from "../images/markers/event/incidentFireUncontrolled.png?h=70&format=png&inline&vite-imagetools";

import incidentCycloneTornado from "../images/markers/event/incidentCycloneTornado.png?h=70&format=png&inline&vite-imagetools";
import incidentEarthquake from "../images/markers/event/incidentEarthquake.png?h=70&format=png&inline&vite-imagetools";
import incidentHazmat from "../images/markers/event/incidentHazmat.png?h=70&format=png&inline&vite-imagetools";
import incidentHealth from "../images/markers/event/incidentHealth.png?h=70&format=png&inline&vite-imagetools";
import incidentOther from "../images/markers/event/incidentOther.png?h=70&format=png&inline&vite-imagetools";
import incidentSmoke from "../images/markers/event/incidentSmoke.png?h=70&format=png&inline&vite-imagetools";
import incidentTsunami from "../images/markers/event/incidentTsunami.png?h=70&format=png&inline&vite-imagetools";
import incidentWeather from "../images/markers/event/incidentWeather.png?h=70&format=png&inline&vite-imagetools";

import incidentAirQuality from "../images/markers/event/incidentAirQuality.png?h=70&format=png&inline&vite-imagetools";
import incidentAssistOtherAgency from "../images/markers/event/incidentAssistance.png?h=70&format=png&inline&vite-imagetools";
import incidentDangerousAnimal from "../images/markers/event/incidentDangerousAnimal.png?h=70&format=png&inline&vite-imagetools";
import incidentFlood from "../images/markers/event/incidentFlood.png?h=70&format=png&inline&vite-imagetools";
import incidentPowerlines from "../images/markers/event/incidentPowerlinesDown.png?h=70&format=png&inline&vite-imagetools";
import incidentSearchRescue from "../images/markers/event/incidentSearchRescue.png?h=70&format=png&inline&vite-imagetools";
import incidentShark from "../images/markers/event/incidentShark.png?h=70&format=png&inline&vite-imagetools";
import incidentStorm from "../images/markers/event/incidentStorm.png?h=70&format=png&inline&vite-imagetools";
import incidentTreeDown from "../images/markers/event/incidentTreeDown.png?h=70&format=png&inline&vite-imagetools";

// Generic icons
import genericBlue from "../images/markers/generic/markerGenericBlue.png?h=66&format=png&inline&vite-imagetools";
import genericOrange from "../images/markers/generic/markerGenericOrange.png?h=66&format=png&inline&vite-imagetools";
import genericPink from "../images/markers/generic/markerGenericPink.png?h=66&format=png&inline&vite-imagetools";

// Misc
import transparent1x1 from "../images/markers/generic/1x1.png?h=1&format=png&inline&vite-imagetools";

import incidentVehicleAccident from "../images/markers/event/incidentVehicleAccident.png?h=70&format=png&inline&vite-imagetools";
import predictFire from "../images/markers/event/predictFire.png";

// hi2/HiMiniCamera
import mediaCamera from "../images/markers/media/mediaCamera.png?h=48&format=png&inline&vite-imagetools";
import mediaVideoCamera from "../images/markers/media/mediaVideoCamera.png?h=48&format=png&inline&vite-imagetools";

// Source marker sizes
const WARNING_MARKER_H = 76;
const INCIDENT_MARKER_H = 70;
const ADVISORY_MARKER_H = 56;
// const GENERIC_MARKER_H = 66;
// const GENERIC_MARKER_W = 33;

// Target marker sizes
const WARNING_MARKER_TARGET_H = 38;
const INCIDENT_MARKER_TARGET_H = 35;
const ADVISORY_MARKER_TARGET_H = 28;

// Scale sizes
export const KNOWN_MARKER_SCALES: Record<BfMapLayerGroupId, number | null> = {
    Warnings: WARNING_MARKER_TARGET_H / WARNING_MARKER_H,
    WeatherWarnings: ADVISORY_MARKER_TARGET_H / ADVISORY_MARKER_H,
    Incidents: INCIDENT_MARKER_TARGET_H / INCIDENT_MARKER_H,
    PlannedBurns: INCIDENT_MARKER_TARGET_H / INCIDENT_MARKER_H,
    Aircraft: 1.0,
    HazardousRoads: 1.0,
    ClosedRoads: 1.0,
    Hotspots: null,
    Velocity: null,
    BurnAreas: null,
    Notifications: null,
    Lightning: null,
    NotUserSelectable: null,
    Weather: null,
    CustomLayers: null,
    GeoSatellite: null,
    Basemap: null,
    Radar: null,
    FireDanger: null,
    Ignitions: null,
    Media: 0.4,
};

export const KNOWN_MARKERS: Record<BfMapMarkerType, MarkerDef> = {
    [BfMapMarkerType.warningUnknown]: {
        payload: pngWarningGenericUnknown,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningNotApplicable]: {
        payload: pngWarningGenericNa,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFireAdvice]: {
        payload: pngWarningFireAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Generic
    [BfMapMarkerType.warningInformation]: {
        payload: pngWarningGenericInformation,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningGenericWhite]: {
        payload: pngWarningGenericWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningGenericAdvice]: {
        payload: pngWarningGenericAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningGenericWatchAndAct]: {
        payload: pngWarningGenericWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningGenericEmergencyWarning]: {
        payload: pngWarningGenericEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Cyclone
    [BfMapMarkerType.warningCycloneWhite]: {
        payload: pngWarningCycloneWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningCycloneAdvice]: {
        payload: pngWarningCycloneAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningCycloneWatchAndAct]: {
        payload: pngWarningCycloneWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningCycloneEmergencyWarning]: {
        payload: pngWarningCycloneEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Flood
    [BfMapMarkerType.warningFloodWhite]: {
        payload: pngWarningFloodWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFloodAdvice]: {
        payload: pngWarningFloodAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFloodWatchAndAct]: {
        payload: pngWarningFloodWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFloodEmergencyWarning]: {
        payload: pngWarningFloodEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Storm
    [BfMapMarkerType.warningStormWhite]: {
        payload: pngWarningStormWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningStormAdvice]: {
        payload: pngWarningStormAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningStormWatchAndAct]: {
        payload: pngWarningStormWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningStormEmergencyWarning]: {
        payload: pngWarningStormEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Heat
    [BfMapMarkerType.warningHeatWhite]: {
        payload: pngWarningHeatWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningHeatAdvice]: {
        payload: pngWarningHeatAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningHeatWatchAndAct]: {
        payload: pngWarningHeatWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningHeatEmergencyWarning]: {
        payload: pngWarningHeatEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    // Evacuation
    [BfMapMarkerType.warningEvacuationWhite]: {
        payload: pngWarningEvacuationWhite,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningEvacuationAdvice]: {
        payload: pngWarningEvacuationAdvice,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningEvacuationWatchAndAct]: {
        payload: pngWarningEvacuationWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningEvacuationEmergencyWarning]: {
        payload: pngWarningEvacuationEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningEvacuationEvacuateNow]: {
        payload: pngWarningEvacuationEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },

    [BfMapMarkerType.warningFireEvacuateNow]: {
        payload: pngWarningGenericEvacuate,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFireWatchAndAct]: {
        payload: pngWarningFireWatchAndAct,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },
    [BfMapMarkerType.warningFireEmergencyWarning]: {
        payload: pngWarningFireEmergency,
        // curHeight: WARNING_MARKER_H,
        // curWidth: WARNING_MARKER_H,
    },

    [BfMapMarkerType.burnArea]: {
        payload: transparent1x1,
        // curHeight: 1,
        // curWidth: 1,
    },
    [BfMapMarkerType.roadClosed]: {
        payload: pngRoadClosed,
        // curHeight: 16,
        // curWidth: 16,
    },
    [BfMapMarkerType.roadHazard]: {
        payload: pngRoadHazard,
        // curHeight: 16,
        // curWidth: 16,
    },

    // Aircraft - Active
    [BfMapMarkerType.aircraftDefaultActive]: {
        payload: pngAircraftHeavyActive,
        // curHeight: 35,
        // curWidth: 35,
    },
    [BfMapMarkerType.aircraftDefaultLightActive]: {
        payload: pngAircraftLightActive,
        // curHeight: 36,
        // curWidth: 36,
    },
    [BfMapMarkerType.aircraftDefaultMediumActive]: {
        payload: pngAircraftMediumActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftDefaultHeavyActive]: {
        payload: pngAircraftHeavyActive,
        // curHeight: 35,
        // curWidth: 35,
    },
    [BfMapMarkerType.aircraftHelicopterActive]: {
        payload: pngAircraftHelicopterActive,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftJet4HeavyActive]: {
        payload: pngAircraftJet4HeavyActive,
        // curHeight: 60,
        // curWidth: 60,
    },
    [BfMapMarkerType.aircraftJet2HeavyActive]: {
        payload: pngAircraftJet2HeavyActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftJet4MediumActive]: {
        payload: pngAircraftJet4MediumActive,
        // curHeight: 57,
        // curWidth: 57,
    },
    [BfMapMarkerType.aircraftJet2MediumActive]: {
        payload: pngAircraftJet2MediumActive,
        // curHeight: 57,
        // curWidth: 57,
    },
    [BfMapMarkerType.aircraftJet2LightActive]: {
        payload: pngAircraftJet2LightActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo4Active]: {
        payload: pngAircraftTurbo4Active,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo4MediumActive]: {
        payload: pngAircraftTurbo4MediumActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo2MediumActive]: {
        payload: pngAircraftTurbo2MediumActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo1MediumActive]: {
        payload: pngAircraftTurbo1MediumActive,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftTurbo2LightActive]: {
        payload: pngAircraftTurbo2LightActive,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo1LightActive]: {
        payload: pngAircraftTurbo1LightActive,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftProp2LightActive]: {
        payload: pngAircraftProp2LightActive,
        // curHeight: 36,
        // curWidth: 36,
    },
    [BfMapMarkerType.aircraftProp1LightActive]: {
        payload: pngAircraftProp1LightActive,
        // curHeight: 32,
        // curWidth: 32,
    },

    // Aircraft - Inactive
    [BfMapMarkerType.aircraftDefault]: {
        payload: pngAircraftHeavy,
        // curHeight: 35,
        // curWidth: 35,
    },
    [BfMapMarkerType.aircraftDefaultLight]: {
        payload: pngAircraftLight,
        // curHeight: 36,
        // curWidth: 36,
    },
    [BfMapMarkerType.aircraftDefaultMedium]: {
        payload: pngAircraftMedium,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftDefaultHeavy]: {
        payload: pngAircraftHeavy,
        // curHeight: 35,
        // curWidth: 35,
    },
    [BfMapMarkerType.aircraftHelicopter]: {
        payload: pngAircraftHelicopter,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftJet4Heavy]: {
        payload: pngAircraftJet4Heavy,
        // curHeight: 60,
        // curWidth: 60,
    },
    [BfMapMarkerType.aircraftJet2Heavy]: {
        payload: pngAircraftJet2Heavy,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftJet2Medium]: {
        payload: pngAircraftJet2Medium,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftJet4Medium]: {
        payload: pngAircraftJet4Medium,
        // curHeight: 57,
        // curWidth: 57,
    },
    [BfMapMarkerType.aircraftJet2Light]: {
        payload: pngAircraftJet2Light,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo4]: {
        payload: pngAircraftTurbo4,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo4Medium]: {
        payload: pngAircraftTurbo4Medium,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo2Medium]: {
        payload: pngAircraftTurbo2Medium,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo1Medium]: {
        payload: pngAircraftTurbo1Medium,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftTurbo2Light]: {
        payload: pngAircraftTurbo2Light,
        // curHeight: 40,
        // curWidth: 40,
    },
    [BfMapMarkerType.aircraftTurbo1Light]: {
        payload: pngAircraftTurbo1Light,
        // curHeight: 32,
        // curWidth: 32,
    },
    [BfMapMarkerType.aircraftProp2Light]: {
        payload: pngAircraftProp2Light,
        // curHeight: 36,
        // curWidth: 36,
    },
    [BfMapMarkerType.aircraftProp1Light]: {
        payload: pngAircraftProp1Light,
        // curHeight: 32,
        // curWidth: 32,
    },

    [BfMapMarkerType.incidentFireUncontrolled]: {
        payload: incidentFireUncontrolled,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentFireControlled]: {
        payload: incidentFireControlled,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentFireBurn]: {
        payload: incidentFireBurn,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },

    [BfMapMarkerType.incidentWindDamaging]: {
        payload: incidentWindDamaging,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },

    [BfMapMarkerType.incidentCycloneTornado]: {
        payload: incidentCycloneTornado,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentEarthquake]: {
        payload: incidentEarthquake,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentSmoke]: {
        payload: incidentSmoke,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentTsunami]: {
        payload: incidentTsunami,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentWeather]: {
        payload: incidentWeather,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentHazmat]: {
        payload: incidentHazmat,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentHealth]: {
        payload: incidentHealth,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    [BfMapMarkerType.incidentOther]: {
        payload: incidentOther,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentAirQuality: {
        payload: incidentAirQuality,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentDangerousAnimal: {
        payload: incidentDangerousAnimal,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentPowerlines: {
        payload: incidentPowerlines,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentAssistOtherAgency: {
        payload: incidentAssistOtherAgency,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentShark: {
        payload: incidentShark,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentTreeDown: {
        payload: incidentTreeDown,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentFlood: {
        payload: incidentFlood,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentSearchRescue: {
        payload: incidentSearchRescue,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },
    incidentStorm: {
        payload: incidentStorm,
        // curHeight: INCIDENT_MARKER_H,
        // curWidth: INCIDENT_MARKER_H,
    },

    [BfMapMarkerType.advisoryDamagingWinds]: {
        payload: advisoryDamagingWinds,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryFlood]: {
        payload: advisoryFlood,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryCycloneTornado]: {
        payload: advisoryCycloneTornado,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryHail]: {
        payload: advisoryHail,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryEarthquake]: {
        payload: advisoryEarthquake,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryFireWeather]: {
        payload: advisoryFireWeather,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryStorm]: {
        payload: advisoryStorm,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    [BfMapMarkerType.advisoryOther]: {
        payload: advisoryOther,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },

    [BfMapMarkerType.cyclonePosition]: {
        payload: advisoryCycloneTornado,
        // curHeight: ADVISORY_MARKER_H,
        // curWidth: ADVISORY_MARKER_H,
    },
    markerGenericPink: {
        // curWidth: GENERIC_MARKER_W,
        // curHeight: GENERIC_MARKER_H,
        payload: genericPink,
    },
    markerGenericOrange: {
        // curWidth: GENERIC_MARKER_W,
        // curHeight: GENERIC_MARKER_H,
        payload: genericOrange,
    },
    markerGenericBlue: {
        // curWidth: GENERIC_MARKER_W,
        // curHeight: GENERIC_MARKER_H,
        payload: genericBlue,
    },
    predictFire: {
        // curWidth: INCIDENT_MARKER_H,
        // curHeight: INCIDENT_MARKER_H,
        payload: predictFire,
    },
    incidentVehicleAccident: {
        // curWidth: INCIDENT_MARKER_H,
        // curHeight: INCIDENT_MARKER_H,
        payload: incidentVehicleAccident,
    },
    mediaVideoCamera: {
        // curWidth: 32,
        // curHeight: 32,
        payload: mediaVideoCamera,
    },
    mediaCamera: {
        // curWidth: 32,
        // curHeight: 32,
        payload: mediaCamera,
    },
};

export type MarkerDef = {
    // // curWidth: number;
    // // curHeight: number;
    payload: string;
    url?: string;
};

const loadImage = (path: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // to avoid CORS if used with Canvas
        img.src = path;
        img.onload = () => {
            resolve(img);
        };
        img.onerror = (e) => {
            reject(e);
        };
    });
};

/** Outlined marker variants; suffixes must match the image ids in the API's iconImage expressions. */
export type MarkerOutlineVariant = "auto" | "predicted";

const OUTLINE_VARIANTS: Record<MarkerOutlineVariant, { suffix: string; colour: string }> = {
    auto: { suffix: "-auto", colour: "#A855F7" },
    predicted: { suffix: "-predicted", colour: "#EC4899" },
};

const OUTLINE_PAD = 6;
const OUTLINE_RADIUS = 4;

/** Resolve a suffixed map image id (e.g. "incidentFireUncontrolled-predicted") to its base marker and variant. */
export const matchOutlinedImageId = (
    imageId: string
): { markerName: BfMapMarkerType; variant: MarkerOutlineVariant } | null => {
    for (const variant of Object.keys(OUTLINE_VARIANTS) as MarkerOutlineVariant[]) {
        const { suffix } = OUTLINE_VARIANTS[variant];
        if (!imageId.endsWith(suffix)) continue;

        const baseId = imageId.slice(0, -suffix.length);
        if (baseId in KNOWN_MARKERS) {
            return { markerName: baseId as BfMapMarkerType, variant };
        }
    }
    return null;
};

/** Outline variant an event's marker should render with, if any. */
export const markerVariantForOrigin = (
    origin: BfEventOrigin | null | undefined
): MarkerOutlineVariant | undefined => {
    if (origin === BfEventOrigin.automated) return "auto";
    if (origin === BfEventOrigin.predicted) return "predicted";
    return undefined;
};

export class MarkerManager {
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    private silhouetteCanvas: HTMLCanvasElement;
    private silhouetteContext: CanvasRenderingContext2D;
    private outlinedVariants = new Map<string, Promise<ImageData | ImageBitmap | null>>();
    private outlinedUrls = new Map<string, Promise<string | null>>();

    public constructor() {
        this.canvas = window.document.createElement("canvas");
        if (DEBUG_MODE) console.log("Markers getContext");
        const context = this.canvas.getContext("2d", { willReadFrequently: true });

        if (!context) throw new Error("failed to create canvas 2d context");
        this.context = context;

        this.silhouetteCanvas = window.document.createElement("canvas");
        const silhouetteContext = this.silhouetteCanvas.getContext("2d");
        if (!silhouetteContext) throw new Error("failed to create canvas 2d context");
        this.silhouetteContext = silhouetteContext;
    }

    public async blobUrl(markerName: BfMapMarkerType): Promise<string | null> {
        const marker = KNOWN_MARKERS[markerName];

        // Already built, so return that
        if (marker.url) {
            return marker.url;
        }

        const url = URL.createObjectURL(await fetch(marker.payload).then((r) => r.blob()));

        // Save for next lookup
        marker.url = url;

        return url;
    }

    public async mapboxImageData(
        markerName: BfMapMarkerType
    ): Promise<ImageData | ImageBitmap | null> {
        const marker = KNOWN_MARKERS[markerName];
        const img = await loadImage(marker.payload);

        if ("createImageBitmap" in window && window.createImageBitmap) {
            const bitmap = await window.createImageBitmap(img);
            return bitmap;
        }

        this.canvas.width = 64;
        this.canvas.height = 64;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
        return this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }

    /** Marker image with a coloured outline. Falls back to the plain marker on failure. */
    public outlinedImageData(
        markerName: BfMapMarkerType,
        variant: MarkerOutlineVariant
    ): Promise<ImageData | ImageBitmap | null> {
        const key = `${variant}:${markerName}`;
        const existing = this.outlinedVariants.get(key);
        if (existing) return existing;

        const generated = this.buildOutlinedVariant(markerName, variant).catch((ex) => {
            console.error(`failed to build ${variant} marker variant for ${markerName}`, ex);
            return this.mapboxImageData(markerName);
        });

        this.outlinedVariants.set(key, generated);
        return generated;
    }

    /** Data URL of an outlined variant, for use outside Mapbox (e.g. the legend). */
    public outlinedDataUrl(
        markerName: BfMapMarkerType,
        variant: MarkerOutlineVariant
    ): Promise<string | null> {
        const key = `${variant}:${markerName}`;
        const existing = this.outlinedUrls.get(key);
        if (existing) return existing;

        const generated = this.outlinedImageData(markerName, variant).then((image) => {
            if (!image || !(image instanceof ImageData)) return null;

            // No awaits between resize and toDataURL: the shared canvas is safe from interleaving
            this.canvas.width = image.width;
            this.canvas.height = image.height;
            this.context.putImageData(image, 0, 0);
            return this.canvas.toDataURL();
        });

        this.outlinedUrls.set(key, generated);
        return generated;
    }

    private async buildOutlinedVariant(
        markerName: BfMapMarkerType,
        variant: MarkerOutlineVariant
    ): Promise<ImageData> {
        const img = await loadImage(KNOWN_MARKERS[markerName].payload);

        // No awaits below: both shared canvases are safe from interleaving
        this.silhouetteCanvas.width = img.width;
        this.silhouetteCanvas.height = img.height;
        this.silhouetteContext.globalCompositeOperation = "source-over";
        this.silhouetteContext.drawImage(img, 0, 0);
        this.silhouetteContext.globalCompositeOperation = "source-in";
        this.silhouetteContext.fillStyle = OUTLINE_VARIANTS[variant].colour;
        this.silhouetteContext.fillRect(0, 0, img.width, img.height);

        this.canvas.width = img.width + OUTLINE_PAD * 2;
        this.canvas.height = img.height + OUTLINE_PAD * 2;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        for (let step = 0; step < 16; step++) {
            const angle = (step * Math.PI) / 8;
            for (const radius of [OUTLINE_RADIUS, OUTLINE_RADIUS / 2]) {
                this.context.drawImage(
                    this.silhouetteCanvas,
                    OUTLINE_PAD + Math.cos(angle) * radius,
                    OUTLINE_PAD + Math.sin(angle) * radius
                );
            }
        }

        this.context.drawImage(img, OUTLINE_PAD, OUTLINE_PAD);
        return this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
}

let uiMarkerManager: MarkerManager | null = null;

/** Shared MarkerManager for UI components; Mapbox owns its own instance. Null if canvas is unavailable. */
export const uiMarkers = (): MarkerManager | null => {
    if (!uiMarkerManager) {
        try {
            uiMarkerManager = new MarkerManager();
        } catch {
            return null;
        }
    }
    return uiMarkerManager;
};
